import { render, staticRenderFns } from "./EditGrid.vue?vue&type=template&id=5ba97c34&scoped=true"
import script from "./EditGrid.vue?vue&type=script&lang=js"
export * from "./EditGrid.vue?vue&type=script&lang=js"
import style0 from "./EditGrid.vue?vue&type=style&index=0&id=5ba97c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba97c34",
  null
  
)

export default component.exports